import { Injectable, OnDestroy, inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  CanActivateFn
} from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { SpinnerService } from '../service/spinner.service';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
class PermissionsService implements OnDestroy {
  private unsubscribe: Subscription[] = [];

  ngOnDestroy() {
    this.unsubscribe.forEach((s) => s.unsubscribe());
  }

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinnerService: SpinnerService
  ) {
    // to show a spinner on lazy load route
    this.unsubscribe.push(
      router.events.subscribe((event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.spinnerService.show();
        } else if (event instanceof RouteConfigLoadEnd) {
          this.spinnerService.hide();
        }
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (route.data['roles'].indexOf('None') !== -1) {
      if (
        route.routeConfig.path === 'login' &&
        this.authenticationService.getJwt() !== ''
      ) {
        this.router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    }

    const role = this.authenticationService.getRole();

    if (role) {
      // Vérifier si le JWT est expiré
      if (this.authenticationService.isJwtExpired()) {
        // Token expiré — le refresh sera tenté par l'ErrorInterceptor au prochain appel API.
        // On redirige vers login pour forcer un re-login ou refresh.
        this.spinnerService.hide();
        this.authenticationService.logout();
        return false;
      }

      if (route.data['roles'] && route.data['roles'].indexOf(role) === -1) {
        this.router.navigate(['/login']);
        this.spinnerService.hide();
        return false;
      }
      return true;
    }
    if (route.routeConfig.path === 'login') {
      this.spinnerService.hide();
      return true;
    }
    this.spinnerService.hide();
    this.authenticationService.logout();
    return false;
  }
}
export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  return inject(PermissionsService).canActivate(next, state);
};
